import { Button } from "@mui/material"
import { useState } from "react"
import AddFaculty from "../modals/AddFaculty"
import { getAllTeacher, getTeacherFilters, getTeacherSort } from "../../api"
import ListData from "../common/ListData"
import AddRoundedIcon from "@mui/icons-material/AddRounded"
import FacultyCard from "../cards/FacultyCard"

const Faculty = ({ programData }) => {
  const [addFacultyModal, setAddFacultyModal] = useState(false)

  const CTA = () => (
    <Button
      onClick={() => setAddFacultyModal(true)}
      variant="contained"
      startIcon={<AddRoundedIcon />}
    >
      Add Faculty
    </Button>
  )

  return (
    <>
      <ListData
        getFilters={getTeacherFilters}
        getSort={getTeacherSort}
        getAllData={getAllTeacher}
        initialFilters={{}}
        HeaderRight={CTA}
        Card={FacultyCard}
      />
      <AddFaculty
        isOpen={addFacultyModal}
        close={() => setAddFacultyModal(false)}
        programData={programData}
      />
    </>
  )
}

export default Faculty
